export default "__VITE_ASSET__D$AHSKgH__"